// noinspection SpellCheckingInspection,JSUnusedGlobalSymbols

export enum DocumentFileType {
  UNKNOWN = 'unknown',
  PDF = 'application/pdf',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ODT = 'application/vnd.oasis.opendocument.text',
  // A work agreement's own documents may also be these (#6052). A CSV is stored as plain text.
  TXT = 'text/plain',
  ODS = 'application/vnd.oasis.opendocument.spreadsheet',
  ODP = 'application/vnd.oasis.opendocument.presentation',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  PPT = 'application/vnd.ms-powerpoint',
  PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  JPG = 'image/jpeg',
  PNG = 'image/png',
  GIF = 'image/gif',
  BMP = 'image/bmp',
  SVG = 'image/svg+xml',
  WEBP = 'image/webp',
  // Every chat attachment type is a work document type too (#6055).
  HEIC = 'image/heic',
  HEIF = 'image/heif',
  ZIP = 'application/zip',
}
